// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__149v1","title":"Header_title__j6WuF","left":"Header_left__1C1E-","clinicName":"Header_clinicName__Pj363"};